export enum ERRORS {
  // App state actions.
  ALREADY_CALLED = 'ALREADY_CALLED'
}
